function t(t){return t}export{t as default};
